import { UserLanguageType } from "@Components/Modules/Helpers";
import type { IStepperItem, IStepperLine } from "@Components/Stepper/Stepper";

import StepBasket from "@Assets/StepBasket.svg";
import StepCircleArrows from "@Assets/StepCircleArrows.svg";
import StepCoins from "@Assets/StepCoins.svg";
import StepGoodieLogo from "@Assets/StepGoodieLogo.svg";

import { CashbackLandingPageResources } from "./CashbackLandingPage.Resources";
import { CashbackLandingPageResourcesEn } from "./CashbackLandingPage.Resources.En";

const getLineInfo = (isMobile: boolean) => {
    if (isMobile) {
        return {
            height: "80%",
            width: "0",
        } as IStepperLine;
    }

    return {
        height: "0",
        width: "100%",
    } as IStepperLine;
};

const stepperSteps = (language: UserLanguageType) => {
    const resources =
        language === UserLanguageType.English
            ? CashbackLandingPageResourcesEn.whatIsCashback
            : CashbackLandingPageResources.whatIsCashback;

    const stepList: IStepperItem[] = [
        {
            title: resources.step1Title,
            description: resources.step1Description,
            svgFile: StepGoodieLogo,
        },
        {
            title: resources.step2Title,
            description: resources.step2Description,
            svgFile: StepBasket,
        },
        {
            title: resources.step3Title,
            description: resources.step3Description,
            svgFile: StepCoins,
        },
        {
            title: resources.step4Title,
            description: resources.step4Description,
            svgFile: StepCircleArrows,
        },
    ];

    return stepList;
};

export { stepperSteps, getLineInfo };
